var DATE_PART = {
  YEAR: 'year',
  MONTH: 'month',
  DAY: 'day'
};
var FOCUS_ELEMENT = {
  TOGGLE_PICKER: 'togglePicker',
  PREV_MONTH: 'prevMonth',
  NEXT_MONTH: 'nextMonth',
  DAY: 'day'
};

export { DATE_PART, FOCUS_ELEMENT };
